// -----------------------------------------------------------------------------------------------------

// The file is a utility file to handle video player functionality. It is responsible for doing the following:

// • Pause / Play the triggered video
// • Mute / Unmute

// -----------------------------------------------------------------------------------------------------

// -----------------------------------------------------------------------------------------------------
// Video utility: Play / Pause + Mute / Unmute
// -----------------------------------------------------------------------------------------------------

const allVideoPlayers = document.querySelectorAll('.video__Container');

allVideoPlayers.forEach(videoPlayer => {
  const parentWrapper = videoPlayer.parentElement;
  const video = videoPlayer.querySelector('video');
  const videoStateBtns = parentWrapper.querySelectorAll('.video__Control--state');
  const videoSoundBtns = parentWrapper.querySelectorAll('.video__Control--sound');

  // Initial state
  videoPlayer.classList.add('video--is-paused');

  // --------------------------------------------------
  // Container click → toggle play / pause
  // --------------------------------------------------
  videoPlayer.addEventListener('click', e => {
    e.stopPropagation();
    video.paused ? video.play() : video.pause();
  });

  // --------------------------------------------------
  // State buttons → play / pause
  // --------------------------------------------------
  videoStateBtns.forEach(btn => {
    btn.addEventListener('click', e => {
      e.stopPropagation();
      video.paused ? video.play() : video.pause();
    });
  });

  // --------------------------------------------------
  // Sound buttons → mute / unmute
  // --------------------------------------------------
  videoSoundBtns.forEach(btn => {
    btn.addEventListener('click', e => {
      e.stopPropagation();
      video.muted = !video.muted;
    });
  });

  // --------------------------------------------------
  // Sync play / pause classes
  // --------------------------------------------------
  video?.addEventListener('play', () => {
    videoPlayer.classList.remove('video--is-paused');
    videoPlayer.classList.add('video--is-playing');
  });

  video?.addEventListener('pause', () => {
    videoPlayer.classList.remove('video--is-playing');
    videoPlayer.classList.add('video--is-paused');
  });

  // --------------------------------------------------
  // Sync sound classes
  // --------------------------------------------------
  video?.addEventListener('volumechange', () => {
    if (video.muted) {
      videoPlayer.classList.add('video--muted');
      videoPlayer.classList.remove('video--sound');
    } else {
      videoPlayer.classList.remove('video--muted');
      videoPlayer.classList.add('video--sound');
    }
  });
});

// --------------------------------------------------
// Window resize → pause + mute any playing videos
// --------------------------------------------------
window.addEventListener('resize', () => {
  allVideoPlayers.forEach(videoPlayer => {
    const video = videoPlayer.querySelector('video');

    if (!video) return;

    if (!video.paused) {
      video.pause();
    }

    if (!video.muted) {
      video.muted = true;
    }
  });
});